// @ts-strict-ignore
import clsx from 'clsx'
import { memo } from 'react'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

import { CardType } from '../../types/types'

import cl from './price.module.scss'

interface PriceProps {
	price: number
	oldPrice?: number
	showPrice?: boolean
	type?: CardType
	unavailable?: boolean
}

export const Price = memo((props: PriceProps) => {
	const { type, price, oldPrice = 0, showPrice = true, unavailable = false } = props

	const renderPrice = price > 0
	const renderOldPrice = oldPrice > 0 && price !== oldPrice

	const formattedPrice = formatPrice(price)
	const formattedOldPrice = renderOldPrice ? formatPrice(oldPrice) : null

	return (
		<div
			className={clsx(cl.price, cl[type], {
				[cl.unavailable]: unavailable
			})}>
			{showPrice && renderPrice && (
				<>
					<p className={cl.price__actual}>{formattedPrice}</p>
					{renderOldPrice && <p className={cl.price__old}>{formattedOldPrice}</p>}
				</>
			)}
		</div>
	)
})
